module.exports = __webpack_public_path__ + "static/Abacus Human Resources Funktionen LEHMANNPARTNER-94d673f337b9e3cd4b230379b5facb77.pdf";